import { copyToClipboard } from 'utils/clipboard-utils';
import { handleSignInSignUpClick } from 'utils/auth-utils';
import { RouteStore } from 'bernie-core';
import { showTerms } from 'utils/dialog-utils';

export enum KNOWN_ACTIONS {
  COPY = 'copy',
  AUTHWINDOW = 'authwindow',
  TERMS_AND_CONDITIONS = 'terms_and_conditions'
}

interface ResolveActionParameter {
  actionDetails?: ResolveActionBehaviorStructure;
}

interface ResolveActionBehaviorStructure {
  name: string;
  details: string;
}

export class MessagingCardActions {
  public static resolveAction(
    routeStore: RouteStore,
    param: ResolveActionParameter,
    analytics: any = null,
    showNotification: () => void = null
  ): (e: Event) => void {
    const { actionDetails } = param;
    const stringActionName = actionDetails && actionDetails.name.trim().toUpperCase();
    const enumAction = KNOWN_ACTIONS[stringActionName];

    if (enumAction) {
      return (e: Event) => {
        e.preventDefault();
        e.stopPropagation();

        switch (enumAction) {
          case KNOWN_ACTIONS.TERMS_AND_CONDITIONS:
            showTerms(routeStore, analytics, actionDetails.details);
            break;
          case KNOWN_ACTIONS.COPY:
            copyToClipboard(actionDetails.details, showNotification);
            break;
          case KNOWN_ACTIONS.AUTHWINDOW:
            handleSignInSignUpClick(e, analytics, actionDetails.details);
            break;
        }
      };
    }

    return;
  }
}
